@if (sent) {
  <div>
    <h2>Your request has been sent</h2>
    <button ca-raised-button color="primary" (click)="reset.emit()">
      Send Another
    </button>
  </div>
}
